let resumeData = {
  "name": "Gaje Robarge",
  "role": "Software Developer and DeadHead",
  "linkedinId": "https://www.linkedin.com/in/gaje-robarge",
  "roleDescription": "I enjoy Learning new technologies while being creative and effecient",
  "socialLinks": [
    {
      "name": "linkedin",
      "url": "https://www.linkedin.com/in/gaje-robarge",
      "className": "fa fa-linkedin"
    },
    {
      "name": "github",
      "url": "hhttps://github.com/Grobarge",
      "className": "fa fa-github"
    },

  ],
  "aboutme": "I am currently a freelance Software Developer. When I'm not hunched over my screen you can usually find me listening to music or playing my instruments. I also love to do the usual Utah things like go hiking, camping, have fires. You know, all the fun stuff!",
  "aboutme2": "Email: robargegaje@gmail.com",
  "email": "Cell: 385-685-3550",
  "education": [
    {
      "UniversityName": "Devmountain",
      "specialization": "Full Stack Web Development",
      "MonthOfPassing": "Jan",
      "YearOfPassing": "2019",
    },
    {
      "UniversityName": "MTECH",
      "specialization": "Information Technology",
      "MonthOfPassing": "May",
      "YearOfPassing": "2017",
      "Achievements": "Comptia PC Tech Pro",
      "Achievements2": "Comptia Networking Pro",
      "Achievements3": "Comptia Security Pro"
    }
  ],
  "work": [
    {
      "CompanyName": "Self Employed",
      "specialization": "Software Developer",
      "MonthOfLeaving": "March",
      "YearOfLeaving": "2020- ",
      "Achievements": "Web and Mobile Applications",
      "Achievements2": "IT Consulting",
      "Achievements3": "Wordpress, Shopify Developer"
    },
    {
      "CompanyName": "Paul Mitchell Schools",
      "specialization": "Software Developer",
      "MonthOfLeaving": "August 2019 -",
      "YearOfLeaving": "April 2020",
      "Achievements": "Develop internal tools to integrate with our current softwares in order to communicate with eachother",
      "Achievements2": "Manage and create content, functionality for school's training site",
      "Achievements3": "Work closely with Marketing & IT to get current business needs fulfilled. "
    },
    {
      "CompanyName": "BidMyCrib",
      "specialization": "Freelance Web Developer",
      "MonthOfLeaving": "May 2019 - ",
      "YearOfLeaving": "September 2019",
      "Achievements": "Created website from scratch for Bidmycrib.com"
    },
    {
      "CompanyName": "Skyline Solar",
      "specialization": "Web Developer",
      "MonthOfLeaving": "April 2018 -",
      "YearOfLeaving": "April 2019 - ",
      "Achievements": "Created a web app for our sales guys to schedule appointmnets and input customer information into",
      "Achievements4": "Created an online store for skyline employees to purchase/win gear and swag",
      "Achievements5": "Work closely with Owners to plan and execute features of the web app"
    },
  ],
  // "skillsDescription": "Your skills here",
  // "skills": [
  //   {
  //     "skillname": "HTML5"
  //   },
  //   {
  //     "skillname": "CSS"
  //   },
  //   {
  //     "skillname": "Reactjs"
  //   },
  //   {
  //     "skillname": "wordpress"
  //   },
  //   {
  //     "skillname": "NodeJs"
  //   },
  //   {
  //     "skillname": "Git"
  //   }
  // ],
  "portfolio": [
    {
      "name": "Biskue",
      "description": "Full Stack Web App",
    },
    {
      "name": "project2",
      "description": "mobileapp",
      "imgurl": "images/portfolio/project.jpg"
    },
    {
      "name": "project3",
      "description": "mobileapp",
      "imgurl": "images/portfolio/project2.png"
    },
    {
      "name": "project4",
      "description": "mobileapp",
      "imgurl": "images/portfolio/phone.jpg"
    }
  ],
  "testimonials": [
    {
      "description": "This is a sample testimonial",
      "name": "Some technical guy"
    },
    {
      "description": "This is a sample testimonial",
      "name": "Some technical guy"
    }
  ]
}

export default resumeData